'use client';
import cn from 'classnames';
import Image from 'next/image';

import Button from '@/components/common/Button/Button';

import CheckmarkBlack from 'public/img/icon/checkmark-black.svg';

import './EllaSelectProductIcon.style.scss';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

type EllaSelectProductIconProps = {
  selected: boolean;
  isProcessing: boolean;
  className?: string;
};

function EllaSelectProductIcon(props: EllaSelectProductIconProps) {
  const { className = '', selected, isProcessing } = props;

  return (
    <div
      className={cn('EllaSelectProductIcon', className, {
        selected: isProcessing || selected
      })}
    >
      {isProcessing ? (
        <LoadingSpinner
          size={26}
          gradient='from 90deg,rgba(39, 174, 96, 0) 0deg,rgba(149, 149, 149, 0) 0.036deg,rgba(149, 149, 149, 1) 360deg'
        >
          <Image
            src={CheckmarkBlack}
            alt=''
          />
        </LoadingSpinner>
      ) : (
        <Image
          src={CheckmarkBlack}
          alt=''
        />
      )}
    </div>
  );
}

export default EllaSelectProductIcon;
